<template>
  <a-col :sm="{span:24}" :md="{span:24}" :lg="{span:12}" :xl="{span:12}" :xxl="{span:12}" class="assign-admin reviewers-section">
    <a-card title="Assign New Interim Reviewer" :style="{ marginTop: '16px' }">
      <div class="reviewer-name">
        <label :span="12" v-html="'Interim Reviewer Name'"/>
        <a-select
          showSearch
          mode="default"
          labelInValue
          :value="reviewerValue"
          placeholder="Search..."
          style="width: 100%"
          :filterOption="false"
          @search="fetchReviewer"
          @change="ReviewerChange"
          :notFoundContent="fetchingReviewer ? 'Searching' : 'Not Found'"
          :disabled="courseDetails.assesment_data.assigned_admin_reviewer_status !== 'completed'"
          >
          <a-spin v-if="fetchingReviewer" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in reviewerUserData" :key="d.value">{{d.text}}
          </a-select-option>
        </a-select>
        <a-button type="dashed" :style="{ float: 'right', marginTop: '20px' }"
          @click="assignAssessor(reviewerValue, 'interim_reviewer')"
          v-if="Object.entries(reviewerValue).length > 0">
          Assign
        </a-button>
      </div>
    </a-card>
  </a-col>
</template>
<script>
import { mapActions } from 'vuex';
import baseURL from '@/api/http-common';

export default {
  name: 'assign-interim-reviewer',
  data() {
    this.lastFecthedId = 0;
    return {
      reviewerUserData: [],
      reviewerValue: [],
      fetchingReviewer: false,
    };
  },
  props: [
    'courseDetails',
    'userToken',
    'successMessage',
    'reviewerLevel',
  ],
  methods: {
    ...mapActions('courses', {
      createAssessment: 'createAssessment',
    }),
    fetchReviewer(value) {
      this.lastFecthedId += 1;
      const fetchId = this.lastFecthedId;
      this.fetchingReviewer = true;
      const userObj = ((localStorage.getItem('telasUserObj') !== null) && (localStorage.getItem('telasUserObj').length > 0)) ? JSON.parse(localStorage.getItem('telasUserObj')) : '';
      const userToken = userObj.token;
      fetch(`${baseURL}wp/v2/users/?per_page=100&search=${value}&meta[0][key]=telas_assessor_level&meta[0][value]=telas_interim_reviewers&meta[1][key]=activated_by_admin&meta[1][value]=yes&meta[2][key]=user_available&meta[2][value]=no&meta[2][compare]=NOT LIKE`, { method: 'GET', headers: { Authorization: `Bearer ${userToken}` } })
        .then(response => response.json())
        .then((body) => {
          if (fetchId !== this.lastFecthedId) { // for fetch callback order
            return;
          }
          const data = body.map(user => ({
            text: `${user.name}`,
            value: String(user.id),
          }));

          this.reviewerUserData = data;
          this.fetchingReviewer = false;
        });
    },
    ReviewerChange(value) {
      this.reviewerValue = value;
    },
    assignAssessor(assessorValue, reviewerLevel) {
      const createAssessmentArgs = {
        ...assessorValue,
        ...{
          courseId: this.$route.params.courseId,
          reviewerLevel,
          userToken: this.userToken,
        },
      };
      this.createAssessment(createAssessmentArgs);
    },
  },
};
</script>
